import BaseComponent from "../../baseComponent.js";
import DatasetDetailHeader from "./header/datasetDetailHeader.jsx";
import InternalEvent from "../../../core/constants/internalEvent.js";
import Content from "./content/content.jsx";
import styles from "./dataset-detail.scss";

export default class DatasetDetail extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.$modal = $("#dataset-detail-modal");
    this.$modal.modal({
      dismissible: true,

      ready: (modal, trigger) => {
        // header has z-index of 10000 to avoid flickering text
        $(modal).css("z-index", 11001);
        $(".modal-overlay").css("z-index", 11000);
      },
      complete: () => {
        this.props.onModalClose();
      }
    });
    this.show();
    $(window).on("resize", this.onWindowResize);
  }

  componentWillUnmount() {
    $(window).off("resize", this.onWindowResize);
  }

  onWindowResize() {
    let widget = $("#preview-widget").find("div[id]").parent();
    this.publish(InternalEvent.Dashboard.WIDGET_RESIZE, {widget: widget});
  }

  show() {
    this.$modal.modal("open");
  }

  response(value){
    if(this.props.response == true && value == true) {
      this.props.callback(value);
    }
  }

  render() {
    let header, content;
    if (this.props.dataset != null && this.props.subscriptions != null) {
      header = <DatasetDetailHeader dataset={this.props.dataset}/>;
      content = <Content dataset={this.props.dataset} subscriptions={this.props.subscriptions} response={this.response} control={this.props.tabControl}/>;
    }
    return (
      <div className={["modal", styles.modalContainer].join(" ")} id="dataset-detail-modal">
        <div className="modal-content" style={{padding: 0, height: "100%"}}>
          <div className={styles.datasetDetail}>
            {header}
            {content}
          </div>
        </div>
      </div>
    )
  }
}













// WEBPACK FOOTER //
// ./src/components/data-bank/dataset-detail/datasetDetail.jsx